"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderMessageBarGroup_unstable", {
    enumerable: true,
    get: function() {
        return renderMessageBarGroup_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reacttransitiongroup = require("react-transition-group");
const _MessageBarTransition = require("./MessageBarTransition");
const renderMessageBarGroup_unstable = (state)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_reacttransitiongroup.TransitionGroup, {
            component: null,
            children: state.children.map((child)=>/*#__PURE__*/ (0, _jsxruntime.jsx)(_MessageBarTransition.MessageBarTransition, {
                    animate: state.animate,
                    enterClassName: state.enterStyles,
                    exitClassName: state.exitStyles,
                    children: child
                }, child.key))
        })
    });
};
